import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useResponsiveContext } from "../Responsive";
import { FullscreenContext } from "./FullscreenContext";
import { addFullScreenListeners, exitFullScreen, isFullScreenActive, lockFullscreenOrientation, removeFullScreenListeners, requestFullscreen } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var FullscreenProvider = function FullscreenProvider(_ref) {
  var playerRef = _ref.playerRef,
    onFullscreen = _ref.onFullscreen,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'landscape' : _ref$orientation,
    children = _ref.children;
  var _useResponsiveContext = useResponsiveContext(),
    recalculatePlayerSize = _useResponsiveContext.recalculatePlayerSize;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    fullscreenIsAvailable = _useState2[0],
    setFullscreenIsAvailable = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFullscreen = _useState4[0],
    setIsFullscreen = _useState4[1];
  useEffect(function () {
    var onFullscreenChange = function onFullscreenChange() {
      var isFullscreenValue = isFullScreenActive();
      setIsFullscreen(isFullscreenValue);
      recalculatePlayerSize();
      if (onFullscreen) {
        onFullscreen(isFullscreenValue);
      }
    };
    var playerElement = playerRef.current;

    // Add listeners to the whole player element
    addFullScreenListeners({
      playerElement: playerElement,
      onFullscreenChange: onFullscreenChange
    });
    return function () {
      removeFullScreenListeners({
        playerElement: playerElement,
        onFullscreenChange: onFullscreenChange
      });
    };
    // We're ignoring the onFullscreen prop, assuming it doesn't change after the first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerRef, recalculatePlayerSize]);
  var toggleFullscreen = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var fullscreenPromise;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!isFullScreenActive()) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return exitFullScreen();
        case 3:
          _context.next = 6;
          break;
        case 5:
          if (playerRef.current) {
            fullscreenPromise = requestFullscreen({
              playerElement: playerRef.current
            });
            fullscreenPromise.then(function () {
              lockFullscreenOrientation({
                orientation: orientation
              });
              setFullscreenIsAvailable(true);
            })["catch"](function () {
              setFullscreenIsAvailable(false);
            });
          }
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [playerRef, orientation]);
  var contextValue = useMemo(function () {
    return {
      fullscreenIsAvailable: fullscreenIsAvailable,
      isFullscreen: isFullscreen,
      toggleFullscreen: toggleFullscreen
    };
  }, [fullscreenIsAvailable, isFullscreen, toggleFullscreen]);
  return /*#__PURE__*/_jsx(FullscreenContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default FullscreenProvider;